import React, { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useFormik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCameraRetro } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { AddHeader } from "../../components/AddHeader";
import "../../components/Editprofile.css";
import profile from "../../components/funtionsBD/Mainservice";
import { editprofile, getlevel } from "../../components/funtionsBD/Mainservice";
import { ip_back } from "../../config";
import { FOCUS_OTHER_ATTRIBUTE_ID } from "../../constants/focusAttributes.js";
import { userHasPlayerRole } from "../../utils/homeRole";



export const EditProfile = () => {

  
  const [pictures, setPictures] = useState([]);
  const [success, setsuccess] = useState(false);
  const [open, setOpen] = useState(false);
  const [initialFormValues, setInitialFormValues] = useState(null);
  const [levels, setLevels] = useState([]);
  const [userMainPurpose, setUserMainPurpose] = useState(null);
  const [availableAttributes, setAvailableAttributes] = useState([]);
  const [user, setUser] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  

    const validate = (values) => {
    const errors = {};

    if (!values.fname) {
      errors.fname = `${t("require")}`;
    } else if (values.fname.length > 100) {
      errors.fname = `${t("must")}`;
    }
    if (values.alias && values.alias.length > 100) {
      errors.alias = `${t("must")}`;
    }
    if (!values.email) {
      errors.email = `${t("require")}`;
    }
    if (!values.bday) {
      errors.bday = `${t("require")}`;
    }
    return errors;
  };

  const handlesubmit = async (values, { resetForm }) => {
    try {
      // Map basic levels back to competition levels for recreational players
      const submitValues = { ...values };
      
      if (userMainPurpose && userMainPurpose !== 3 && values.level) {
        // Map basic levels back to competition levels for database storage
        switch (values.level) {
          case 'Beginner':
            submitValues.level = 'C3';
            break;
          case 'Intermediate':
            submitValues.level = 'B1';
            break;
          case 'Advanced':
            submitValues.level = 'A1';
            break;
          default:
            submitValues.level = values.level;
        }
      }
      
      const response = await editprofile(pictures, submitValues);
      
      // Update focuses separately
      if (values.primaryFocus || (values.secondaryFocuses && values.secondaryFocuses.length > 0)) {
        try {
          const focusResponse = await fetch(`${ip_back.replace(/\/$/, '')}/api/user/updateFocuses`, {
            method: 'PUT',
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              primaryFocusId: values.primaryFocus || null,
              secondaryFocusIds: values.secondaryFocuses || [],
              primaryFocusCustomText: values.primaryFocusCustomText || '',
              secondaryFocusCustomText: values.secondaryFocusCustomText || '',
              mainPurposeId: userMainPurpose,
            })
          });
          
          if (focusResponse.ok) {
            console.log('✅ Focuses updated successfully');
          }
        } catch (focusError) {
          console.log('Error updating focuses:', focusError);
        }
      }
      
      // Update localStorage with the new user data
      localStorage.setItem("user", JSON.stringify(response.data.data));
      window.dispatchEvent(
        new CustomEvent("smarttt-user-updated", {
          detail: response.data.data,
        })
      );

      // Show success message
      setsuccess(response.data.message);
      setOpen(true);
      
      // Redirect to profile page after a short delay to show the success message
      setTimeout(() => {
        navigate('/profile');
      }, 1500);
    } catch (error) {
      // Handle error silently in production
    }
  };

  // Define getprofile function that will be called after formik is initialized
  const getprofile = async () => {
    try {
      // Check token
      const token = localStorage.getItem("token");
      
      if (typeof profile !== 'function') {
        return;
      }
      
      const response = await profile();
      
      // The backend returns data in response.data.data (nested structure)
      const user = response.data.data;
      
      // Store user data for level filtering
      console.log('🔍 User main_purpose_id:', user.main_purpose_id);
      console.log('🔍 User country:', user.country);
      setUser(user);
      setUserMainPurpose(user.main_purpose_id);
      
      // Get level display value
      let levelDisplay = "";
      if (user.player_level && user.player_level.level_name) {
        const levelName = user.player_level.level_name;
        
        // If user is not a competition player, map competition levels to basic levels
        if (user.main_purpose_id && user.main_purpose_id !== 3) {
          // Map competition levels to basic levels for recreational/health players
          switch (levelName) {
            case 'C3':
              levelDisplay = t('beginner');
              break;
            case 'B1':
              levelDisplay = t('intermediate');
              break;
            case 'A1':
              levelDisplay = t('advanced');
              break;
            default:
              levelDisplay = levelName;
          }
        } else {
          // Competition player - show actual level
          levelDisplay = levelName;
        }
      }
      
      // Get style display value
      let styleDisplay = "";
      if (user.style) {
        // Try translations first (for internationalization)
        if (user.style.translations && user.style.translations[0] && user.style.translations[0].name) {
          styleDisplay = user.style.translations[0].name;
        }
        // Fallback to style_name if translations are not available
        else if (user.style.style_name) {
          styleDisplay = user.style.style_name;
        }
      }
      
      // Access player data with fallbacks
      const playerGrip = user.player_grip || user.dataValues?.player_grip || "";
      const playerHand = user.player_hand || user.dataValues?.player_hand || "";
      
      // Get focus data
      let primaryFocus = "";
      let secondaryFocuses = [];
      let primaryFocusCustomText = "";
      let secondaryFocusCustomText = "";

      if (user.userFocuses) {
        const pf = user.userFocuses.primary;
        if (pf) {
          primaryFocus = pf.attribute_id || "";
          if (pf.custom_text && String(pf.custom_text).trim()) {
            primaryFocus = FOCUS_OTHER_ATTRIBUTE_ID;
            primaryFocusCustomText = String(pf.custom_text).trim();
          }
        }
        secondaryFocuses = user.userFocuses.secondary?.map((f) => {
          if (f.custom_text && String(f.custom_text).trim()) {
            secondaryFocusCustomText = String(f.custom_text).trim();
            return FOCUS_OTHER_ATTRIBUTE_ID;
          }
          return f.attribute_id;
        }) || [];
      }

      const formValues = {
        alias: user.user_alias || "",
        fname: user.user_first_name,
        lname: user.user_last_name,
        email: user.user_email,
        gender: user.user_sex,
        bday: user.user_date_birth ? user.user_date_birth.split("T")[0] : "",
        type: user.type_user_id,
        clubid: user.club_id,
        img: user.user_image,
        grip: playerGrip,
        hand: playerHand,
        level: levelDisplay,
        style: styleDisplay,
        primaryFocus: primaryFocus,
        secondaryFocuses: secondaryFocuses,
        primaryFocusCustomText,
        secondaryFocusCustomText,
      };
      
      // Store values to set later when formik is ready
      setInitialFormValues(formValues);
      
      // Force a re-render by updating a state variable
      setOpen(prev => !prev);
    } catch (error) {
      // Handle error silently in production
    }
  };

  const formik = useFormik({
    initialValues: {
      alias: "",
      fname: "",
      lname: "",
      email: "",
      clubid: "",
      gender: "male",
      bday: "",
      img: "",
      type: "",
      grip: "",
      hand: "",
      level: "",
      style: "",
      primaryFocus: "",
      secondaryFocuses: [],
      primaryFocusCustomText: "",
      secondaryFocusCustomText: "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      handlesubmit(values, { resetForm });
    },
  });

  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    getprofile();
    loadLevels();
    loadAvailableAttributes();
  }, []);

  // Load levels from the backend
  const loadLevels = async () => {
    try {
      console.log('🔄 Loading levels...');
      const response = await getlevel();
      console.log('📡 Levels response:', response.data);
      if (response.data.status === "success") {
        setLevels(response.data.data);
        console.log('✅ Levels loaded:', response.data.data.length, 'levels');
      } else {
        console.log('❌ Failed to load levels:', response.data);
      }
    } catch (error) {
      console.log("❌ Error loading levels:", error);
    }
  };

  // Load available attributes for focus selection
  const loadAvailableAttributes = async () => {
    try {
      console.log('🔄 Loading available attributes...');
      const response = await fetch(`${ip_back.replace(/\/$/, '')}/api/user/availableAttributes`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('📡 Response status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('📊 Available attributes response:', data);
        if (data.status === "success") {
          setAvailableAttributes(data.data);
          console.log('✅ Available attributes loaded:', data.data.length, 'attributes');
        }
      } else {
        console.log('❌ Failed to load attributes, status:', response.status);
      }
    } catch (error) {
      console.log("❌ Error loading available attributes:", error);
    }
  };

  // Filter levels based on user's main purpose and country
  const getFilteredLevels = () => {
    console.log('🔍 getFilteredLevels - levels.length:', levels.length, 'userMainPurpose:', userMainPurpose, 'userCountry:', user?.country);
    
    // If no levels loaded, return empty array
    if (!levels.length) {
      console.log('⚠️ No levels loaded, returning empty array');
      return [];
    }

    // Check if user is from Luxembourg (based on club or country)
    const isLuxembourgUser = user?.country === 'LU' || 
                            user?.country === 'Luxembourg' || 
                            user?.club_name?.includes('Esch') ||
                            user?.club_id?.includes('cl_1758124012707'); // DT Esch Abol club ID

    console.log('🔍 Is Luxembourg user:', isLuxembourgUser, 'club_name:', user?.club_name);

    // If user is a competition player (main_purpose_id = 3), show appropriate levels
    if (userMainPurpose === 3) {
      // For Luxembourg competition players, show Luxembourg classification levels (A1, A2, etc.)
      if (isLuxembourgUser) {
        const luxembourgLevels = levels.filter(level => 
          level.level_name && 
          (level.level_name.includes('A1') || 
           level.level_name.includes('A2') || 
           level.level_name.includes('A3') ||
           level.level_name.includes('B1') || 
           level.level_name.includes('B2') || 
           level.level_name.includes('B3') ||
           level.level_name.includes('C1') || 
           level.level_name.includes('C2') || 
           level.level_name.includes('C3') ||
           level.level_name.includes('D'))
        );
        console.log('🇱🇺 Luxembourg competition player, showing classification levels:', luxembourgLevels.length);
        return luxembourgLevels;
      } else {
        // For other countries, show all competition levels
        console.log('🌍 International competition player, showing all levels:', levels.length);
        return levels;
      }
    }

    // For Luxembourg users (even if not competition), show Luxembourg levels as default
    if (isLuxembourgUser) {
      const luxembourgLevels = levels.filter(level => 
        level.level_name && 
        (level.level_name.includes('A1') || 
         level.level_name.includes('A2') || 
         level.level_name.includes('A3') ||
         level.level_name.includes('B1') || 
         level.level_name.includes('B2') || 
         level.level_name.includes('B3') ||
         level.level_name.includes('C1') || 
         level.level_name.includes('C2') || 
         level.level_name.includes('C3') ||
         level.level_name.includes('D'))
      );
      console.log('🇱🇺 Luxembourg user, showing classification levels:', luxembourgLevels.length);
      return luxembourgLevels;
    }

    // For recreational/health players or when main_purpose is null, show basic levels
    // Map competition levels to basic levels
    const basicLevels = [
      { level_id: 'basic_beginner', level_name: t('beginner') },
      { level_id: 'basic_intermediate', level_name: t('intermediate') },
      { level_id: 'basic_advanced', level_name: t('advanced') }
    ];

    console.log('✅ Recreational player or null purpose, showing basic levels:', basicLevels.length);
    return basicLevels;
  };

  // Set initial form values when formik is ready and we have initial values
  useEffect(() => {
    if (initialFormValues && formik && formik.setValues) {
      formik.setValues(initialFormValues);
      setInitialFormValues(null); // Clear stored values
    }
  }, [initialFormValues]);

  // Auto-apply CSS styling to ensure text visibility on component mount
  useEffect(() => {
    const applyCSS = () => {
      const selects = document.querySelectorAll('select[name="grip"], select[name="hand"], select[name="level"], select[name="style"], select[name="primaryFocus"], select[name="secondaryFocuses"]');
      
      selects.forEach(select => {
        // Apply aggressive styling to ensure text visibility
        select.style.cssText = `
          color: #0A0615 !important;
          background-color: #ffffff !important;
          font-family: inherit !important;
          font-size: 14px !important;
          font-weight: inherit !important;
          padding: 0 1.25rem !important;
          margin: 0 !important;
          border: 2px solid #e1e5e9 !important;
          border-radius: 12px !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          display: block !important;
          width: 100% !important;
          box-sizing: border-box !important;
          -webkit-text-fill-color: #0A0615 !important;
          text-fill-color: #0A0615 !important;
          opacity: 1 !important;
          visibility: visible !important;
          z-index: 999 !important;
          position: relative !important;
        `;
        
        // Style options with aggressive visibility
        Array.from(select.options).forEach(option => {
          option.style.cssText = `
            color: #0A0615 !important;
            background-color: #ffffff !important;
            font-family: inherit !important;
            font-size: 14px !important;
            padding: 0.5rem !important;
            margin: 0 !important;
            -webkit-text-fill-color: #0A0615 !important;
            text-fill-color: #0A0615 !important;
            opacity: 1 !important;
            visibility: visible !important;
            z-index: 1000 !important;
            position: relative !important;
          `;
        });
      });
    };

    // Apply CSS after delays to ensure DOM is ready and form values are set
    const timer1 = setTimeout(applyCSS, 100);
    const timer2 = setTimeout(applyCSS, 500);
    
    // Also apply CSS immediately
    applyCSS();
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  // Re-apply CSS whenever form values change to ensure visibility
  useEffect(() => {
    const applyCSS = () => {
      const selects = document.querySelectorAll('select[name="grip"], select[name="hand"], select[name="level"], select[name="style"], select[name="primaryFocus"], select[name="secondaryFocuses"]');
      
      selects.forEach(select => {
        // Force text visibility
        select.style.setProperty('color', '#0A0615', 'important');
        select.style.setProperty('-webkit-text-fill-color', '#0A0615', 'important');
        select.style.setProperty('text-fill-color', '#0A0615', 'important');
        select.style.setProperty('opacity', '1', 'important');
        select.style.setProperty('visibility', 'visible', 'important');
      });
    };

    // Apply CSS after form updates
    const timer = setTimeout(applyCSS, 50);
    return () => clearTimeout(timer);
  }, [formik.values.grip, formik.values.hand, formik.values.level, formik.values.style]);



  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    setPictures(file);
    formik.setFieldValue("img", URL.createObjectURL(file));
  };

  return (
    <>
      <div id="adminRoot">
        <AddHeader title={t("editprofile")} />

        <form className="add-exercise" onSubmit={formik.handleSubmit}>
          <div className="edit-pic">
            {formik.values.img && formik.values.img !== null && formik.values.img !== "" ? (
              <img src={formik.values.img} alt="" />
            ) : (
              <div className="profile_img_icon">
                {formik.values.fname ? formik.values.fname.slice(0, 1) : "U"}
              </div>
            )}
            <label htmlFor="profileimg" className="edit-img-label">
              <FontAwesomeIcon icon={faCameraRetro} className="edit-camera" />
            </label>
          </div>
          <input
            className="input_addpicsvg"
            type="file"
            name="profileimg"
            id="profileimg"
            accept="image/*"
            onChange={handleFileInputChange}
          />
          <div className="input-details">
            {/* Basic Information Section */}
            <div className="section-header">
              <h3>Basic Information</h3>
              <p>Update your personal details and contact information</p>
            </div>
            
            <div className="input-detail">
              <label htmlFor="">{t("alias")}</label>
              <input
                placeholder={t("writealias")}
                type="text"
                value={formik.values.alias || ""}
                name="alias"
                onChange={formik.handleChange}
              />
            </div>

            <div className="input-detail">
              <label htmlFor="">{t("firstname")}</label>
              <input
                placeholder={t("writename")}
                type="text"
                value={formik.values.fname || ""}
                name="fname"
                onChange={formik.handleChange}
              />
              {formik.errors.fname && (
                <div className="validation_error">{formik.errors.fname}</div>
              )}
            </div>

            <div className="input-detail">
              <label htmlFor="">{t("lastname")}</label>
              <input
                placeholder={t("writename")}
                type="text"
                value={formik.values.lname || ""}
                name="lname"
                onChange={formik.handleChange}
              />
              {formik.errors.lname && (
                <div className="validation_error">{formik.errors.lname}</div>
              )}
            </div>

            <div className="input-detail">
              <label htmlFor="">{t("birthday")}</label>
              <input
                type="date"
                max={new Date().toISOString().split('T')[0]}
                value={formik.values.bday || ""}
                name="bday"
                onChange={(e) => {
                  formik.setFieldValue('bday', e.target.value);
                }}
              />
              {formik.errors.bday && (
                <div className="validation_error">{formik.errors.bday}</div>
              )}
            </div>

            <div className="input-detail">
              <label htmlFor="">{t("gender")}</label>
              <div className="input-radio-btn">
                <input
                  type="radio"
                  name="gender"
                  value="female"
                  checked={formik.values.gender === "female"}
                  onChange={formik.handleChange}
                />
                <label htmlFor="female">{t("female")}</label>
              </div>
              <div className="input-radio-btn">
                <input
                  type="radio"
                  name="gender"
                  value="male"
                  checked={formik.values.gender === "male"}
                  onChange={formik.handleChange}
                />
                <label htmlFor="male">{t("male")}</label>
              </div>
            </div>

            <div className="input-detail">
              <label htmlFor="">{t("mail")}</label>
              <input
                type="email"
                placeholder={t("enteremail")}
                value={formik.values.email || ""}
                onChange={formik.handleChange}
                name="email"
              />
              {formik.errors.email && (
                <div className="validation_error">{formik.errors.email}</div>
              )}
            </div>

                        {/* Player-specific fields - only show for players */}

            

            


            

            

            





            

            

            
            {/* Player-Specific Fields Section */}
            {userHasPlayerRole(user) && (
              <>
                <div className="section-header">
                  <h3>Playing Profile</h3>
                  <p>Configure your table tennis playing preferences and skills</p>
                </div>
                <div className="input-detail">
                  <label htmlFor="">{t('racketGrip')}</label>
                  <select
                    value={formik.values.grip || ""}
                    name="grip"
                    onChange={formik.handleChange}
                  >
                    <option value="">{t('selectGrip')}</option>
                    <option value="shakehand">{t('shakehand')}</option>
                    <option value="penhold">{t('penhold')}</option>
                  </select>
                </div>

                <div className="input-detail">
                  <label htmlFor="">{t('playingHand')}</label>
                  <select
                    value={formik.values.hand || ""}
                    name="hand"
                    onChange={formik.handleChange}
                  >
                    <option value="">{t('selectHand')}</option>
                    <option value="right">{t('rightHand')}</option>
                    <option value="left">{t('leftHand')}</option>
                  </select>
                </div>

                <div className="input-detail">
                  <label htmlFor="">{t('playingLevel')}</label>
                  <select
                    value={formik.values.level || ""}
                    name="level"
                    onChange={formik.handleChange}
                  >
                    <option value="">{t('selectLevel')}</option>
                    {getFilteredLevels().map((level) => {
                      console.log('🔍 EditProfile rendering level:', level);
                      const displayName = level.level_name || level.level_description || `Level ${level.level_id}`;
                      return (
                        <option key={level.level_id} value={level.level_name}>
                          {displayName}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="input-detail">
                  <label htmlFor="">{t('playingStyle')}</label>
                  <select
                    value={formik.values.style || ""}
                    name="style"
                    onChange={formik.handleChange}
                  >
                    <option value="">{t('selectStyle')}</option>
                    <option value="Offensive">{t('offensive')}</option>
                    <option value="Defensive">{t('defensive')}</option>
                    <option value="All-Round">{t('allRound')}</option>
                  </select>
                </div>

                <div className="input-detail">
                  <label htmlFor="">{t('primaryFocus')} ({availableAttributes.length} available)</label>
                  <select
                    value={formik.values.primaryFocus || ""}
                    name="primaryFocus"
                    onChange={(e) => {
                      formik.handleChange(e);
                      if (Number(e.target.value) !== FOCUS_OTHER_ATTRIBUTE_ID) {
                        formik.setFieldValue('primaryFocusCustomText', '');
                      }
                    }}
                    style={{ 
                      zIndex: 999, 
                      position: 'relative',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      border: '1.5px solid #0877BC'
                    }}
                  >
                    <option value="">{t('selectPrimaryFocus')}</option>
                    {availableAttributes.length > 0 ? (
                      availableAttributes.map((attr) => (
                        <option key={attr.attribute_id} value={attr.attribute_id}>
                          {attr.translated_name || attr.attribute_name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>Loading attributes...</option>
                    )}
                  </select>
                  {Number(formik.values.primaryFocus) === FOCUS_OTHER_ATTRIBUTE_ID && (
                    <div className="input-detail" style={{ marginTop: '0.75rem' }}>
                      <label htmlFor="primaryFocusCustomText">{t('customObjectiveLabel')}</label>
                      <textarea
                        id="primaryFocusCustomText"
                        name="primaryFocusCustomText"
                        className="text-input"
                        style={{ minHeight: '88px', width: '100%', resize: 'vertical' }}
                        value={formik.values.primaryFocusCustomText || ''}
                        onChange={formik.handleChange}
                        placeholder={t('customObjectivePlaceholder')}
                        maxLength={500}
                      />
                    </div>
                  )}
                  {formik.values.primaryFocus && (
                    <div style={{ marginTop: '0.5rem', padding: '0.5rem', background: '#e8f4fd', borderRadius: '6px', fontSize: '12px', border: '1px solid #0877BC' }}>
                      <strong>Selected:</strong> {(() => {
                        const attr = availableAttributes.find(a => a.attribute_id == formik.values.primaryFocus);
                        return attr ? attr.translated_name || attr.attribute_name : formik.values.primaryFocus;
                      })()}
                    </div>
                  )}
                  {console.log('🔍 Available attributes in render:', availableAttributes.length, availableAttributes)}
                  {console.log('🔍 Selected primary focus:', formik.values.primaryFocus)}
                </div>

                <div className="input-detail">
                  <label htmlFor="">{t('secondaryFocuses')} ({availableAttributes.length} available)</label>
                  <select
                    multiple
                    value={formik.values.secondaryFocuses || []}
                    name="secondaryFocuses"
                    onChange={(e) => {
                      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                      const limited = selectedOptions.length <= 2 ? selectedOptions : selectedOptions.slice(0, 2);
                      formik.setFieldValue('secondaryFocuses', limited);
                      if (!limited.includes(String(FOCUS_OTHER_ATTRIBUTE_ID))) {
                        formik.setFieldValue('secondaryFocusCustomText', '');
                      }
                    }}
                    style={{ minHeight: '100px' }}
                  >
                    {availableAttributes.length > 0 ? (
                      availableAttributes.map((attr) => (
                        <option key={attr.attribute_id} value={attr.attribute_id}>
                          {attr.translated_name || attr.attribute_name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>Loading attributes...</option>
                    )}
                  </select>
                  {(formik.values.secondaryFocuses || []).map(String).includes(String(FOCUS_OTHER_ATTRIBUTE_ID)) && (
                    <div className="input-detail" style={{ marginTop: '0.75rem' }}>
                      <label htmlFor="secondaryFocusCustomText">{t('customSecondaryObjectiveLabel')}</label>
                      <textarea
                        id="secondaryFocusCustomText"
                        name="secondaryFocusCustomText"
                        className="text-input"
                        style={{ minHeight: '88px', width: '100%', resize: 'vertical' }}
                        value={formik.values.secondaryFocusCustomText || ''}
                        onChange={formik.handleChange}
                        placeholder={t('customObjectivePlaceholder')}
                        maxLength={500}
                      />
                    </div>
                  )}
                  {formik.values.secondaryFocuses && formik.values.secondaryFocuses.length > 0 && (
                    <div style={{ marginTop: '0.5rem', padding: '0.5rem', background: '#f8f9fa', borderRadius: '6px', fontSize: '12px' }}>
                      <strong>Selected:</strong> {formik.values.secondaryFocuses.map(id => {
                        const attr = availableAttributes.find(a => a.attribute_id == id);
                        return attr ? attr.translated_name || attr.attribute_name : id;
                      }).join(', ')}
                    </div>
                  )}
                  <small>
                    {t('holdCtrlToSelectMultiple')}
                    {formik.values.secondaryFocuses && formik.values.secondaryFocuses.length >= 2 && (
                      <span style={{ color: '#d32f2f', marginLeft: '0.5rem' }}>
                        • {t('secondaryFocusLimitReached')}
                      </span>
                    )}
                    {(!formik.values.secondaryFocuses || formik.values.secondaryFocuses.length < 2) && (
                      <span style={{ color: '#1976d2', marginLeft: '0.5rem' }}>
                        • {t('secondaryFocusSelectUpTo').replace('{count}', (2 - (formik.values.secondaryFocuses?.length || 0)).toString())}
                      </span>
                    )}
                  </small>
                  {console.log('🔍 Available attributes in render:', availableAttributes.length, availableAttributes)}
                  {console.log('🔍 Selected secondary focuses:', formik.values.secondaryFocuses)}
                </div>
              </>
            )}
          </div>

          <div className="submit-section">
            <button className="submit-button" type="submit">
              <span>{t("updateprofile")}</span>
            </button>
          </div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={closealert}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <Alert variant="filled" severity="success">
              {success}
            </Alert>
          </Snackbar>
        </form>
      </div>
    </>
  );
};
